import type { RouteStep } from "./lib/types";
const marks: Record<string, [string, string]> = {
  straight: ["↑", "ישר"], left: ["←", "שמאלה"], right: ["→", "ימינה"],
  "slight left": ["↖", "שמאלה קלות"], "sharp left": ["↰", "שמאלה בחדות"],
  "slight right": ["↗", "ימינה קלות"], "sharp right": ["↱", "ימינה בחדות"],
  uturn: ["↶", "פרסה"], none: ["│", "ללא סימון"],
};
export function LaneGuidance({ step }: { step?: RouteStep }) {
  if (!step?.lanes?.length) return null;
  return <div className="lane-guidance" aria-label="הכוונת נתיבים בצומת הבא">
    <div className="lane-strip" dir="ltr">{step.lanes.map((lane, i) =>
      <div key={i} className={"lane " + (lane.valid ? "lane-valid" : "")}
        aria-label={`נתיב ${i + 1} משמאל: ${lane.indications.map(x => marks[x]?.[1] || x).join(" או ")}${lane.valid ? " — מתאים למסלול" : " — אינו מתאים למסלול"}`}>
        <span aria-hidden="true">{lane.indications.map(x => marks[x]?.[0] || "?").join("")}</span>
      </div>)}</div>
    <small>הנתיבים המודגשים מתאימים למסלול</small>
  </div>;
}
